import React from "react";

function ServicePage() {
  return <div>ServicePage</div>;
}

export default ServicePage;
